import { BaseFieldClass } from './baseField.class'

import { IFloatField } from '@/types/serverField.type'

export class FloatFieldClass extends BaseFieldClass {
  declare fieldValue: number
  declare initialValue: number

  constructor (field: IFloatField) {
    super(field)

    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as number | string | null)
    this.fieldValue = this.prepareValue(value as number | string | null)
  }

  prepareValue (value: number | string | null): number {
    if (value === null) {
      return 0
    }

    return Number(String(value).replace(',', '.')) || 0
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue () {
    return this.fieldValue
  }
}
